import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from '../auth/auth.service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {


  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  
  constructor(private  authService:  AuthService ,public  router:  Router) { }

  ngOnInit() {
    let login = this.authService.isLoggedIn;
    console.log("Login " +login);

    if (login) {
      this.router.navigate(['dashboard/products']);
    }
  }


  onSubmit(event: any) {

    console.log(event.target.username.value);
    console.log(event.target.password.value);
  
    let username = event.target.username.value;
    let password = event.target.password.value;
  
    this.authService.login(username,password);
    //this.authService.logout;
    
  }
}
